import { motion } from "framer-motion";
import { PortableText } from "@portabletext/react";


const TipContent = ({ tip }) => {


    if (!tip) {

        return (

            <div className="
                bg-white
                rounded-3xl
                border
                border-gray-200
                p-8
                text-center
                text-gray-500
            ">
                Loading tip...
            </div>

        );

    }



    return (

        <motion.div

            key={tip._id}

            initial={{
                opacity: 0,
                x: 30
            }}

            animate={{
                opacity: 1,
                x: 0
            }}

            transition={{
                duration: 0.4
            }}

            className="
                bg-white
                rounded-3xl
                border
                border-gray-200
                overflow-hidden
            "

        >



            {/* Image */}

            {
                tip.image?.asset?.url && (

                    <div className="
                        w-full
                        h-56
                        sm:h-72
                        lg:h-80
                        overflow-hidden
                    ">

                        <img

                            src={tip.image.asset.url}

                            alt={tip.title}

                            className="
                                w-full
                                h-full
                                object-cover
                            "

                        />

                    </div>

                )
            }



            {/* Article Content */}

            <div className="
                p-5
                sm:p-8
            ">



                {/* Category */}

                {
                    tip.category && (

                        <span className="
                            inline-block
                            bg-green-100
                            text-green-700
                            text-sm
                            font-medium
                            px-4
                            py-1
                            rounded-full
                        ">

                            {tip.category}

                        </span>

                    )
                }



                <h1 className="
                    mt-5
                    text-2xl
                    sm:text-3xl
                    lg:text-4xl
                    font-bold
                    text-gray-900
                    leading-tight
                ">

                    {tip.title}

                </h1>




                {/* Short Description */}

                {
                    tip.description && (

                        <p className="
                            mt-6
                            text-gray-600
                            text-sm
                            sm:text-base
                            leading-relaxed
                        ">

                            {tip.description}

                        </p>

                    )
                }



                {/* Full Sanity Content */}

                {
                    tip.content && (

                        <div className="
                            mt-8
                            prose
                            max-w-none
                            text-gray-700
                        ">

                            <PortableText value={tip.content} />

                        </div>

                    )
                }



            </div>


        </motion.div>

    );

};


export default TipContent;